import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=9a008e90&scoped=true&"
import script from "./GroupTable.vue?vue&type=script&lang=js&"
export * from "./GroupTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=9a008e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a008e90",
  null
  
)

export default component.exports